import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ErrorStateService, LoggingService, RegistrationStepQuery, RegistrationStepService } from '@fgb/core';
import { RegistrationPartnerInviteComponent } from '@fgb/portal-component-library/src/lib/registration';

@Component({
  selector: 'fgb-registration-partner-invite',
  templateUrl: './registration-partner-invite.component.html',
  styleUrls: ['./registration-partner-invite.component.scss'],
})
export class CustomRegistrationPartnerInviteComponent extends RegistrationPartnerInviteComponent{

  constructor(
    protected _registrationStepQuery: RegistrationStepQuery,
    protected _logService: LoggingService,
    protected _registrationStepService: RegistrationStepService,
    protected _errorService: ErrorStateService,
    protected _fb: UntypedFormBuilder
  ){
    super(_registrationStepQuery, _logService, _registrationStepService, _errorService, _fb);
  }
}
